@if (hasMessages) {
  <div class="flex h-full items-center justify-center">
    <app-messages-empty-state></app-messages-empty-state>
  </div>
} @else {
  <app-single-message></app-single-message>
}
